export default __webpack_public_path__ + "static/media/5.364e1ffb.png";